import { easingType } from "_src/engine/constants";

export default class Animation {

  constructor() {

    this.type = easingType.LINEAR;

    this._from = 0.0;
    this._to = 0.0;

    this._start = 0.0;
    this._current = 0.0;
    this._end = 0.0;

    this._active = false;

    this._onUpdate = () => {};
    this._onFinish = () => {};

  }

  update(elapsed) {

    if (this._active) {

      this._current += elapsed;

      if (this._current >= this._end) {

        this._onFinish(this._to);

        this._active = false;

      } else {

        const value = getValue(this.type, this._current, this._from, this._to, this._end);

        this._onUpdate(value);

      }

    }

  }

  start(from, to, time) {

    this._from = from;
    this._to = to;

    this._start = 0.0;
    this._current = 0.0;
    this._end = time;

    this._active = true;

  }

  setOnUpdate(update) {
    this._onUpdate = update;
  }

  setOnFinish(finish) {
    this._onFinish = finish;
  }

  abort() {
    this._active = false;
  }

  checkBusy() {
    return this._active;
  }

}

function getValue(type, t, b, c, d) {

  switch(type) {
  case easingType.LINEAR:
    return linearTween(t, b, c, d);
  case easingType.IN_QUAD:
    return easeInQuad(t, b, c, d);
  case easingType.OUT_QUAD:
    return easeOutQuad(t, b, c, d);
  case easingType.IN_OUT_QUAD:
    return easeInOutQuad(t, b, c, d);
  case easingType.IN_CUBIC:
    return easeInCubic(t, b, c, d);
  case easingType.OUT_CUBIC:
    return easeOutCubic(t, b, c, d);
  case easingType.IN_OUT_CUBIC:
    return easeInOutCubic(t, b, c, d);
  case easingType.IN_QUART:
    return easeInQuart(t, b, c, d);
  case easingType.OUT_QUART:
    return easeOutQuart(t, b, c, d);
  case easingType.IN_OUT_QUART:
    return easeInOutQuart(t, b, c, d);
  case easingType.IN_QUINT:
    return easeInQuint(t, b, c, d);
  case easingType.OUT_QUINT:
    return easeOutQuint(t, b, c, d);
  case easingType.IN_OUT_QUINT:
    return easeInOutQuint(t, b, c, d);
  case easingType.IN_SINE:
    return easeInSine(t, b, c, d);
  case easingType.OUT_SINE:
    return easeOutSine(t, b, c, d);
  case easingType.IN_OUT_SINE:
    return easeInOutSine(t, b, c, d);
  case easingType.IN_EXPO:
    return easeInExpo(t, b, c, d);
  case easingType.OUT_EXPO:
    return easeOutExpo(t, b, c, d);
  case easingType.IN_OUT_EXPO:
    return easeInOutExpo(t, b, c, d);
  case easingType.IN_CIRC:
    return easeInCirc(t, b, c, d);
  case easingType.OUT_CIRC:
    return easeOutCirc(t, b, c, d);
  case easingType.IN_OUT_CIRC:
    return easeInOutCirc(t, b, c, d);
  case easingType.IN_ELASTIC:
    return easeInElastic(t, b, c, d);
  case easingType.OUT_ELASTIC:
    return easeOutElastic(t, b, c, d);
  case easingType.IN_OUT_ELASTIC:
    return easeInOutElastic(t, b, c, d);
  case easingType.IN_BACK:
    return easeInBack(t, b, c, d);
  case easingType.OUT_BACK:
    return easeOutBack(t, b, c, d);
  case easingType.IN_OUT_BACK:
    return easeInOutBack(t, b, c, d);
  case easingType.IN_BOUNCE:
    return easeInBounce(t, b, c, d);
  case easingType.OUT_BOUNCE:
    return easeOutBounce(t, b, c, d);
  case easingType.IN_OUT_BOUNCE:
    return easeInOutBounce(t, b, c, d);
  default:
    throw "Unsupported easing type.";
  }

}

// t: current time, b: begInnIng value, c: change In value, d: duration
function linearTween(t, b, c, d) {
  return c*t/d + b;
}

function easeInQuad(t, b, c, d) {
  return c*(t/=d)*t + b;
}

function easeOutQuad(t, b, c, d) {
  return -c *(t/=d)*(t-2) + b;
}

function easeInOutQuad(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t + b;
  return -c/2 * ((--t)*(t-2) - 1) + b;
}

function easeInCubic(t, b, c, d) {
  return c*(t/=d)*t*t + b;
}

function easeOutCubic(t, b, c, d) {
  return c*((t=t/d-1)*t*t + 1) + b;
}

function easeInOutCubic(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t + b;
  return c/2*((t-=2)*t*t + 2) + b;
}

function easeInQuart(t, b, c, d) {
  return c*(t/=d)*t*t*t + b;
}

function easeOutQuart(t, b, c, d) {
  return -c * ((t=t/d-1)*t*t*t - 1) + b;
}

function easeInOutQuart(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
  return -c/2 * ((t-=2)*t*t*t - 2) + b;
}

function easeInQuint(t, b, c, d) {
  return c*(t/=d)*t*t*t*t + b;
}

function easeOutQuint(t, b, c, d) {
  return c*((t=t/d-1)*t*t*t*t + 1) + b;
}

function easeInOutQuint(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
  return c/2*((t-=2)*t*t*t*t + 2) + b;
}

function easeInSine(t, b, c, d) {
  return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
}

function easeOutSine(t, b, c, d) {
  return c * Math.sin(t/d * (Math.PI/2)) + b;
}

function easeInOutSine(t, b, c, d) {
  return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
}

function easeInExpo(t, b, c, d) {
  return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
}

function easeOutExpo(t, b, c, d) {
  return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
}

function easeInOutExpo(t, b, c, d) {
  if (t==0) return b;
  if (t==d) return b+c;
  if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
  return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
}

function easeInCirc(t, b, c, d) {
  return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
}

function easeOutCirc(t, b, c, d) {
  return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
}

function easeInOutCirc(t, b, c, d) {
  if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
  return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
}

function easeInElastic(t, b, c, d) {
  var s=1.70158;var p=0;var a=c;
  if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
  if (a < Math.abs(c)) { a=c; s=p/4; }
  else s = p/(2*Math.PI) * Math.asin (c/a);
  return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
}

function easeOutElastic(t, b, c, d) {
  var s=1.70158;var p=0;var a=c;
  if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
  if (a < Math.abs(c)) { a=c; s=p/4; }
  else s = p/(2*Math.PI) * Math.asin (c/a);
  return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
}

function easeInOutElastic(t, b, c, d) {
  var s=1.70158;var p=0;var a=c;
  if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
  if (a < Math.abs(c)) { a=c; s=p/4; }
  else s = p/(2*Math.PI) * Math.asin (c/a);
  if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
  return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
}

function easeInBack(t, b, c, d, s) {
  if (s == undefined) s = 1.70158;
  return c*(t/=d)*t*((s+1)*t - s) + b;
}

function easeOutBack(t, b, c, d, s) {
  if (s == undefined) s = 1.70158;
  return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
}

function easeInOutBack(t, b, c, d, s) {
  if (s == undefined) s = 1.70158;
  if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
  return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
}

function easeInBounce(t, b, c, d) {
  return c - easeOutBounce (d-t, 0, c, d) + b;
}

function easeOutBounce(t, b, c, d) {
  if ((t/=d) < (1/2.75)) {
    return c*(7.5625*t*t) + b;
  } else if (t < (2/2.75)) {
    return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
  } else if (t < (2.5/2.75)) {
    return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
  } else {
    return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
  }
}

function easeInOutBounce(t, b, c, d) {
  if (t < d/2) return easeInBounce (t*2, 0, c, d) * .5 + b;
  return easeOutBounce (t*2-d, 0, c, d) * .5 + c*.5 + b;
}
